import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Icon from 'vue-awesome/components/Icon'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Auth from "@aws-amplify/auth"
// import AuthConfig from '@/aws-exports.js'
import VueHighlightJS from 'vue-highlightjs'

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-144049004-1',
  autoTracking: {
    screenview: true
  }
})

// Vuetify
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
})

import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

// View tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

// Vue cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// set default config
VueCookies.config('1h')

import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
Amplify.configure(awsconfig)

Vue.use(AmplifyPlugin, AmplifyModules)

const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-2:8cd63a38-a66f-4e5a-aad2-9ca9335771e6',
    'aws_cognito_region': 'us-east-2',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'spwebplatform-hosting-mobilehub-68206522',
    'aws_content_delivery_bucket_region': 'us-east-2',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd1r6ve7w3pzhn6.cloudfront.net',
    'aws_mobile_analytics_app_id': '97839b9db0b642298a2ddee62b2aaebf',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '36122dd5-f065-41cf-86c5-9a0d1f6618bb',
    'aws_project_name': 'spWebPlatform',
    'aws_project_region': 'us-east-2',
    'aws_resource_name_prefix': 'spwebplatform-mobilehub-68206522',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-2_6DIl412S8',
    'aws_user_pools_web_client_id': '395i5jceup4mjaippru3ek2huo',
}

// Auth.configure(AuthConfig)

Auth.configure(awsmobile)

Vue.use(BootstrapVue)
Vue.component('icon', Icon)

// Tell Vue.js to use vue-highlightjs
Vue.use(VueHighlightJS)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App),
})
